import { applicantHistoryRequests } from "@/src/api/applicantHistoryRequests";
import { tasksPageRequests } from "@/src/api/tasksPageRequests";
import { tasksStatusConst } from "@/src/constants/tasksConsts";

const IN_PROCESS_STATUS = "in_process";

export interface ExecuteDocumentCheckToCorrectParams {
  taskId: string;
  applicantId?: number;
}

export type ExecuteDocumentCheckToCorrectResult =
  | { ok: true; message: string }
  | { ok: false; message: string };

/** Moves task back to In Process and clears `attached_file`. Document stays in Admissions Office DB. */
export const executeDocumentCheckToCorrect = async ({
  taskId,
  applicantId,
}: ExecuteDocumentCheckToCorrectParams): Promise<ExecuteDocumentCheckToCorrectResult> => {
  await tasksPageRequests.update(taskId, {
    status: IN_PROCESS_STATUS,
    attached_file: null,
  });

  const inProcessLabel = tasksStatusConst.find((item) => item.id === IN_PROCESS_STATUS)?.label ?? IN_PROCESS_STATUS;

  if (applicantId != null && Number.isFinite(applicantId)) {
    try {
      await applicantHistoryRequests.create({
        applicant_id: applicantId,
        text: `Changes have been made to status updated to "${inProcessLabel}"`,
      });
    } catch (error) {
      console.warn("[DocumentCheckToCorrect] History create failed:", error);
    }
  }

  return {
    ok: true,
    message: `Attachment cleared. Task marked as "${inProcessLabel}". Document remains in Admissions Office.`,
  };
};
